// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.popup-box[data-v-5e5f2612] {\n  width: 95%;\n  max-width: 800px;\n  height: 50vh;\n}\n.fullscreen-iframe[data-v-5e5f2612] {\n  width: 100%;\n  height: 360px;\n  border-radius: 10px;\n}\n@media (max-width: 650px){\n.popup-box[data-v-5e5f2612]{\n    width: 95%;\n    height: 100%;\n}\n.fullscreen-iframe[data-v-5e5f2612] {\n    width: 100%;\n    height: 80vh;\n}\n}\n\n", ""]);
// Exports
module.exports = exports;
